export default {"src":"/_next/static/media/legal_zoom_logo.be7d7ded.svg","height":77,"width":296,"blurWidth":0,"blurHeight":0};